/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { excludedKeys } from '../validation';

export default function EditedDataModal({ row, openEdited, handleOpenEdited, handleCloseEdited }) {
    const [modalData, setModalData] = useState([]);

    const prepareModalData = () => {
        try {
            const data = [];

            const traverse = (obj, parentKey = '') => {
                try {
                    for (let key in obj) {
                        if (excludedKeys.includes(key)) {
                            continue;
                        }

                        // Combine the parent key with the current key to track nested keys
                        const fullKey = parentKey ? `${parentKey}.${key}` : key;

                        // Check if the current object contains both newValue and oldValue
                        if (obj[key]?.oldValue !== undefined && obj[key]?.newValue !== undefined) {
                            data.push({
                                section: parentKey, // Separate section (parent key)
                                field: key, // Child key (field name)
                                oldValue: obj[key].oldValue || 'None',
                                newValue: obj[key].newValue || 'None'
                            });
                        }

                        // If it's a nested object, recursively traverse it
                        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                            traverse(obj[key], fullKey); // Pass fullKey to preserve the nested structure
                        }
                    }
                } catch (e) {
                    // console.log('Traverse Issue', e);
                }
            };

            traverse(row.editedData);
            setModalData(data);
        } catch (e) {
            // console.log('Map Issue', e);
        }
    };

    const formatFieldName = (field) => {
        try {
            return field
                .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters in camelCase
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/([a-zA-Z])(\d)/g, '$1 $2') // Handle cases with digits
                .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize the first letter
        } catch (e) {
            // console.log('Field Name', e);
            return '';
        }
    };
    useEffect(() => {
        if (row?.editedData) {
            prepareModalData();
        }
    }, [row.editedData]);

    return (
        <Modal open={openEdited} onClose={handleCloseEdited}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    bgcolor: 'white',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '8px',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}
            >
                <IconButton
                    onClick={handleCloseEdited}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        color: 'grey.500'
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h4" mb={3}>
                    Changes Summary
                </Typography>

                {/* Table to display modalData */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <strong>Section</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Field</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>Old Value</strong>
                                </TableCell>
                                <TableCell>
                                    <strong>New Value</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {modalData.map((item, index) => (
                                <React.Fragment key={index}>
                                    {/* If this is the first occurrence of a section, show the section name */}
                                    {index === 0 || modalData[index - 1].section !== item.section ? (
                                        <TableRow>
                                            <TableCell rowSpan={1 + modalData.filter((i) => i.section === item.section).length}>
                                                {formatFieldName(item.section)}
                                            </TableCell>
                                        </TableRow>
                                    ) : null}
                                    <TableRow>
                                        <TableCell>{formatFieldName(item.field)}</TableCell>
                                        <TableCell>
                                            {typeof item.oldValue === 'object' ? JSON.stringify(item.oldValue) : item.oldValue}
                                        </TableCell>
                                        <TableCell>
                                            {typeof item.newValue === 'object' ? JSON.stringify(item.newValue) : item.newValue}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Modal>
    );
}
